import React from "react";
import * as DIAG from "storm-react-diagrams";
import PreviewLinkView from "./PreviewLinkView";

export default class PreviewLinkFactory extends DIAG.LinkWidgetFactory {
    /**
	 * Link factory for diagram preview
	 * @module PreviewLinkFactory
     */
	constructor() {
		super("default");
	}

    /**
	 * Generator
     * @param {Object} diagramEngine DiagramEngine instance for current diagram
     * @param {Object} link Link model
     * @returns {Object} React element
     */
	generateReactWidget(diagramEngine, link) {
		return React.createElement(PreviewLinkView, {
			link: link,
			diagramEngine: diagramEngine,
			color: "var(--color-link)",
			width: 3,
			smooth: false
		});
	}
}
